import React, { FC } from "react";
import { Badge, COLOR as BADGE_COLOR, HIERARCHY } from "baseui/badge";
import { TableBuilder } from "kanopi-components/TableView/TableView";
import { TransactionStatus } from "kw/api/zeus";
import { useFormatter } from "kw/util/useFormatter";

type TAdminPaymentsSection = {
  payments: TTransactionType[];
};
export const AdminPaymentsSection: FC<TAdminPaymentsSection> = ({ payments }) => {
  const { formatString, formatCurrency } = useFormatter();
  const statusColorMap = {
    [TransactionStatus.ERROR]: BADGE_COLOR.negative,
    [TransactionStatus.IN_PROGRESS]: BADGE_COLOR.warning,
    [TransactionStatus.SUCCESS]: BADGE_COLOR.positive,
  };

  const columnSchema = [
    {
      header: "Transaction ID",
      id: "id",
      children: (row: TTransactionType) => formatString(row.id),
      sortable: false,
    },
    {
      header: "Transaction Type",
      id: "type",
      children: (row: TTransactionType) => formatString(row.transactionTypeDisplay),
      sortable: false,
    },
    {
      header: "Action Type",
      id: "type",
      children: (row: TTransactionType) => formatString(row.actionTypeDisplay),
      sortable: false,
    },
    {
      header: "Policy number",
      id: "policyNumber",
      children: (row: TTransactionType) => formatString(row.policyNumber),
      sortable: false,
    },
    {
      header: "Payment method",
      id: "paymentMethod",
      children: (row: TTransactionType) =>
        formatString(
          (row.paymentProfile?.customerReference &&
            `Credit card #${row.paymentProfile?.customerReference}`) ||
            ""
        ),
      sortable: false,
    },
    {
      header: "Amount",
      id: "amount",
      children: (row: TTransactionType) => formatCurrency(row.amount),
      sortable: false,
    },
    {
      header: "Status",
      id: "status",
      children: (row: TTransactionType) => (
        <Badge
          hierarchy={HIERARCHY.secondary}
          content={formatString(row?.statusDisplay)}
          color={statusColorMap[row?.status] || BADGE_COLOR.accent}
        />
      ),
      overrides: {
        TableHeadCell: {
          style: () => ({
            textAlign: "center",
          }),
        },
        TableBodyCell: {
          style: () => ({
            textAlign: "center",
          }),
        },
      },
      sortable: false,
    },
  ];
  return (
    <TableBuilder
      columnSchema={columnSchema}
      data={payments}
      showSearchSection={false}
      showPagination={false}
      emptyMessage="No payments found"
      data-testid="tableView-PAYMENT"
    />
  );
};
